import { setupCalendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

export const registerVCalendar = (app) => {
  app.use(setupCalendar, {})
  app.component('VDatePicker', DatePicker)
}